import { useEffect, useState } from 'react';
import { useShadowAPI } from '@elfsight/widget-shadow';

export function usePortalNestContainer() {
  const shadowAPI = useShadowAPI();
  const [container, setContainer] = useState(shadowAPI?.root || document.body);

  useEffect(() => {
    if (shadowAPI?.root) {
      setContainer(shadowAPI.root);
    }
  }, [shadowAPI?.root]);

  return container;
}
